module.exports = __webpack_public_path__ + "static/media/login_sm_logo.bf935f25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login_sm_logo.svg
// module id = 205
// module chunks = 0